module.exports = __webpack_public_path__ + "img/0-98.69505d53.jpg";